import {
	TablePage,
	ViewPage,
	EditPage,
	AddPage
} from 'src/views/ping-admin/event-code-link'
import pathMap from 'src/paths/PathMap_Ping'

class PingEventCodeLinkRoute {
	getConfigurations() {
		return [
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_LINK_LIST_VIEW,
				component: TablePage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_LINK_DETAILS_VIEW,
				component: ViewPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_LINK_EDIT_VIEW,
				component: EditPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_CODE_LINK_ADD_VIEW,
				component: AddPage
			}
		]
	}
}

export default PingEventCodeLinkRoute
